import PageLink from 'components/PageLink/PageLink';
import React, { useEffect } from 'react';
import styles from './DisposableIncomeTooLowPageData.module.scss';
import { getGTMVariables, getGTMVariablesPageView  } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const DisposableIncomeTooLowPageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;

  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env);
      getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
    }
  }
    , [LayoutModel]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        <div className="Page-container">
          <article className="Article">
            <div className="Grid Grid--gutterHlg">
              <div className="Grid-cell u-size1of1 u-lg-size3of4 u-xlg-size4of5 SpaceMarginBxsm">
                <h2>{PageData.PageHeader}</h2>
                <p>{PageData.PageHeaderText}</p>
                <p>{PageData.PageHeaderSecondText}</p>
                <div className="Grid Grid--gutterA Grid--gutter-sm-Bz">
                  {PageData.AddressContentArea}
                </div>
              </div>
              <div className="Grid-cell u-size1of1 u-lg-size3of4 u-xlg-size4of5 u-textCenter">
                <h3>{PageData.IncomeTooLowPanelFooter}</h3>
                <div className="ButtonBar u-center">
                  <PageLink
                    className="Button"
                    url={Model.ChooseYourPlanPageUrl}
                    text={PageData.BackToPaymentPlanButtonLabel}
                  />
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default DisposableIncomeTooLowPageData;
